<template>
  <div id="cancelConfirmTaskModal" class="modal fade" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="p-4">
          <h2>{{ translate('Task Cancelled') }}</h2>
          <span class="font-size-125">{{ translate('Your Task has been successfully cancelled.') }}</span>
        </div>
        <div class="modal-footer">
          <button class="btn close-btn" @click.prevent="close">
            <i class="fa fa-times mr-1"></i><strong>{{ translate('Close') }}</strong>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import {EventBus} from '../../events/event.bus';
import currentJob from "../../mixins/current_job.mixin";
import {EVENT_JOB_CANCEL} from "../../events/job.events";
import TransFilter from "../../../mixins/TransFilter.vue";

export default {
  name: 'CancelConfirmTaskModal',
  props: {},
  components: {},
  mixins: [store, currentJob, TransFilter],
  data() {
    return {};
  },
  mounted: function () {
    $('#cancelConfirmTaskModal').modal({show: false});
  },
  created: function () {    
    EventBus.$on(EVENT_JOB_CANCEL, () => {
      $('#cancelConfirmTaskModal').modal('show');
    });
  },
  methods: {
    close() {
      $('#cancelConfirmTaskModal').modal('hide');
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
#cancelConfirmTaskModal {
  .modal-dialog {
    width: 599px;
    max-width: 95%;
    border-radius: 9px;
    overflow: hidden;
  }

  .close-btn {
    background: #d9d9d9;
    height: 38px;
    gap: 10px;
    padding: 0 10px 0 10px;
    font-weight: 600;
  }

  .modal-content-title {
    font-size: 28px;
    font-weight: 600;
  }

  .modal-content {
    h2 {
      margin-top: 0;
    }

    font-size: 17.5px;
    border: 1px solid #ccc;

    p {
      font-size: 17.5px;
    }
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    display: flex;
    padding: 10px 10px;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    background: #f8f9fa;

    .btn {
      margin: 0;
    }
  }
}
</style>
